import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
    selector: 'mlp-ng-day',
    templateUrl: './day.component.html',
    styleUrls: ['./day.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})

export class DaySharedComponent {
    @Input() dateInput: Date;
}
